<template>
  <div class="wrapper">
    <transition mode="out-in" name="fade">
      <Component :is="screens[step]" @skip="step=3" @next="step++" @back="$router.back()" :progress="step + 1" :progressTotal="screens.length" />
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";

import PreGameModalChecks from "./PreGameModalChecks.vue";
import PreGameModalQuestions from "./PreGameModalQuestions.vue";
import PreGameModalInstructions from "./PreGameModalInstructions.vue";
import PreGameModalWaiting from "./PreGameModalWaiting.vue";

const screens = [PreGameModalChecks, PreGameModalQuestions, PreGameModalInstructions, PreGameModalWaiting];

const step = ref(0);
</script>
